
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambulante-ediciones",
      function () {
        return require("private-next-pages/ambulante-ediciones/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambulante-ediciones"])
      });
    }
  